import React, { useEffect, useState } from 'react'
import ItemsTable from '../RestoApp/ItemsTable';

const container = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'linear-gradient(0deg, rgba(24,14,29,1) 0%, rgba(59,34,71,1) 100%)',
    backgroundRepeat: 'noRepeat',
    backgroundAttachment: 'fixed',
    height: '100%'
  }

export default function RestoApp () {
    return (
        <div style={container}>
            <div style={{ height: '100vh' }}>
                <ItemsTable />
            </div>
        </div>
    )
}